import get from "lodash/get";

export function addUpdateProfileSuccessSelector(state: any) {
    let addUpdateProfileSuccess =  get(state, ["admin", "profile" , "addUpdateProfileSuccess"]);
    if(addUpdateProfileSuccess) {
        return addUpdateProfileSuccess;
    }
    return false;
}

export function userProfileImageUploadSelector(state: any) {
    let addUpdateProfileSuccess =  get(state, ["admin", "profile" , "userProfileImageUploadSuccess"]);
    if(addUpdateProfileSuccess) {
        return addUpdateProfileSuccess;
    }
    return false;
}

export function userProfileImageSelector(state: any) {
    let addUpdateProfileSuccess =  get(state, ["admin", "profile" , "userProfileImage"]);
    if(addUpdateProfileSuccess) {
        return addUpdateProfileSuccess;
    }
    return false;
}

export function verifyGstDataSelector(state: any) {
    let verifyGstStatus =  get(state, ["admin", "profile" , "verifyGstStatus"]);
    return verifyGstStatus;
}

export function verifyPanDataSelector(state: any) {
    let verifyPanStatus =  get(state, ["admin", "profile" , "verifyPanStatus"]);
    return verifyPanStatus;
}

export function verifyAadhaarDataSelector(state: any) {
    let verifyAadhaarStatus =  get(state, ["admin", "profile" , "verifyAadhaarStatus"]) || null;
    return verifyAadhaarStatus;
}

export function verifyBankDataSelector(state: any) {
    let verifyBankStatus =  get(state, ["admin", "profile" , "verifyBankStatus"]);
    return verifyBankStatus;
}

export function verifyCINDataSelector(state: any) {
    let verifyCINStatus =  get(state, ["admin", "profile" , "verifyCINStatus"]);
    return verifyCINStatus;
}